"use strict";

function _typeof(obj) { "@babel/helpers - typeof"; if (typeof Symbol === "function" && typeof Symbol.iterator === "symbol") { _typeof = function _typeof(obj) { return typeof obj; }; } else { _typeof = function _typeof(obj) { return obj && typeof Symbol === "function" && obj.constructor === Symbol && obj !== Symbol.prototype ? "symbol" : typeof obj; }; } return _typeof(obj); }

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports["default"] = Slider;

var _react = _interopRequireDefault(require("react"));

var _propTypes = _interopRequireDefault(require("prop-types"));

var _styledComponents = _interopRequireWildcard(require("styled-components"));

var _utils = require("../../utils/utils");

var _BaseInput = _interopRequireDefault(require("../BaseInput"));

function _getRequireWildcardCache() { if (typeof WeakMap !== "function") return null; var cache = new WeakMap(); _getRequireWildcardCache = function _getRequireWildcardCache() { return cache; }; return cache; }

function _interopRequireWildcard(obj) { if (obj && obj.__esModule) { return obj; } if (obj === null || _typeof(obj) !== "object" && typeof obj !== "function") { return { "default": obj }; } var cache = _getRequireWildcardCache(); if (cache && cache.has(obj)) { return cache.get(obj); } var newObj = {}; var hasPropertyDescriptor = Object.defineProperty && Object.getOwnPropertyDescriptor; for (var key in obj) { if (Object.prototype.hasOwnProperty.call(obj, key)) { var desc = hasPropertyDescriptor ? Object.getOwnPropertyDescriptor(obj, key) : null; if (desc && (desc.get || desc.set)) { Object.defineProperty(newObj, key, desc); } else { newObj[key] = obj[key]; } } } newObj["default"] = obj; if (cache) { cache.set(obj, newObj); } return newObj; }

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { "default": obj }; }

function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _slicedToArray(arr, i) { return _arrayWithHoles(arr) || _iterableToArrayLimit(arr, i) || _unsupportedIterableToArray(arr, i) || _nonIterableRest(); }

function _nonIterableRest() { throw new TypeError("Invalid attempt to destructure non-iterable instance.\nIn order to be iterable, non-array objects must have a [Symbol.iterator]() method."); }

function _unsupportedIterableToArray(o, minLen) { if (!o) return; if (typeof o === "string") return _arrayLikeToArray(o, minLen); var n = Object.prototype.toString.call(o).slice(8, -1); if (n === "Object" && o.constructor) n = o.constructor.name; if (n === "Map" || n === "Set") return Array.from(o); if (n === "Arguments" || /^(?:Ui|I)nt(?:8|16|32)(?:Clamped)?Array$/.test(n)) return _arrayLikeToArray(o, minLen); }

function _arrayLikeToArray(arr, len) { if (len == null || len > arr.length) len = arr.length; for (var i = 0, arr2 = new Array(len); i < len; i++) { arr2[i] = arr[i]; } return arr2; }

function _iterableToArrayLimit(arr, i) { if (typeof Symbol === "undefined" || !(Symbol.iterator in Object(arr))) return; var _arr = []; var _n = true; var _d = false; var _e = undefined; try { for (var _i = arr[Symbol.iterator](), _s; !(_n = (_s = _i.next()).done); _n = true) { _arr.push(_s.value); if (i && _arr.length === i) break; } } catch (err) { _d = true; _e = err; } finally { try { if (!_n && _i["return"] != null) _i["return"](); } finally { if (_d) throw _e; } } return _arr; }

function _arrayWithHoles(arr) { if (Array.isArray(arr)) return arr; }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

var trackHeight = 16;
var thumbSize = 24;

var thumbSvg = function thumbSvg(fill) {
  return "url('data:image/svg+xml,".concat((0, _utils.encodeSVG)("<svg xmlns=\"http://www.w3.org/2000/svg\" viewBox=\"0 0 8 8\" height=\"16\" width=\"16\"><path d=\"M3.23 2.65c.2.2.2.5 0 .7L2.6 4l.64.65a.5.5 0 0 1-.7.7l-1-1a.5.5 0 0 1 0-.7l1-1c.2-.2.5-.2.7 0zm3.24 1.01c.2.2.2.51 0 .7l-1 1a.5.5 0 1 1-.7-.7l.64-.65-.64-.64a.5.5 0 1 1 .7-.7l1 1z\" fill=\"".concat(fill, "\"></path></svg>")), "')");
};

var thumbStyle = (0, _styledComponents.css)(["z-index:1;border-radius:50%;height:", "px;width:", "px;background:", ";background-image:", ";background-repeat:no-repeat;background-position:center;appearance:none;cursor:pointer;"], thumbSize, thumbSize, function (props) {
  return props.theme.color.paper;
}, function (props) {
  return thumbSvg(props.theme.color.action);
});
var thumbDisabledStyle = (0, _styledComponents.css)(["background-image:", ";cursor:default;"], function (props) {
  return thumbSvg(props.theme.color.disabled);
});

var Container = _styledComponents["default"].div.withConfig({
  displayName: "Slider__Container",
  componentId: "cn3f4q-0"
})(["display:flex;position:relative;width:calc(100% - 0.5rem);margin:0 0.25rem;height:2.25rem;align-items:center;justify-content:center;"]);

var StyledRangeInput = (0, _styledComponents["default"])(_BaseInput["default"]).withConfig({
  displayName: "Slider__StyledRangeInput",
  componentId: "cn3f4q-1"
})(function (props) {
  return (0, _styledComponents.css)(["height:", "px;width:100%;outline:none;appearance:none;border-radius:", "px;transition:box-shadow 250ms ease;+ span{transition:box-shadow 250ms ease;}::-webkit-slider-runnable-track,::-moz-range-track,::-ms-track{width:100%;height:", "px;cursor:pointer;border-radius:", "px;appearance:none;}::-webkit-slider-thumb{", ";}::-moz-range-thumb{", ";border:0;}:not([disabled]):hover{box-shadow:0 0 0 2px ", ";+ span{box-shadow:0 0 0 2px ", ";}}:not([disabled]):focus{box-shadow:0 0 0 4px ", ";+ span{box-shadow:0 0 0 4px ", ";}}:disabled{background:repeat ", ";::-webkit-slider-thumb{", "}::-moz-range-thumb{", "}}"], trackHeight, trackHeight * 2, trackHeight, trackHeight * 2, thumbStyle, thumbStyle, props.theme.color.hover, props.theme.color.hover, props.theme.color.focus, props.theme.color.focus, props.theme.pattern.disabled, thumbDisabledStyle, thumbDisabledStyle);
});

var ThumbFocus = _styledComponents["default"].span.withConfig({
  displayName: "Slider__ThumbFocus",
  componentId: "cn3f4q-2"
})(["z-index:-1;position:absolute;top:", "px;border-radius:50%;height:", "px;width:", "px;align-self:center;pointer-events:none;"], thumbSize / 4, thumbSize, thumbSize);
/**
 *
 * ### A styled range type input component

This component is intended to be used for a slider/ranged value. It is a React controlled component so requires its value to be passed in via the `value` prop and controlled by a parent stateful component. Any internal side effects to this value will be emitted via the `onChange` and `onChangeEnd` callbacks. As with a standard range input you can only pass in a min, max and step values to alter its behaviour.
 */


function Slider(_ref) {
  var id = _ref.id,
      name = _ref.name,
      _ref$disabled = _ref.disabled,
      disabled = _ref$disabled === void 0 ? false : _ref$disabled,
      _ref$value = _ref.value,
      value = _ref$value === void 0 ? 50 : _ref$value,
      _ref$min = _ref.min,
      min = _ref$min === void 0 ? 0 : _ref$min,
      _ref$max = _ref.max,
      max = _ref$max === void 0 ? 100 : _ref$max,
      _ref$step = _ref.step,
      step = _ref$step === void 0 ? 1 : _ref$step,
      _ref$onChange = _ref.onChange,
      onChange = _ref$onChange === void 0 ? function () {} : _ref$onChange,
      _ref$onChangeEnd = _ref.onChangeEnd,
      onChangeEnd = _ref$onChangeEnd === void 0 ? function () {} : _ref$onChangeEnd,
      rest = _objectWithoutProperties(_ref, ["id", "name", "disabled", "value", "min", "max", "step", "onChange", "onChangeEnd"]);

  var theme = _react["default"].useContext(_styledComponents.ThemeContext);

  var _React$useState = _react["default"].useState(0),
      _React$useState2 = _slicedToArray(_React$useState, 2),
      thumbFocusPosition = _React$useState2[0],
      setThumbFocusPosition = _React$useState2[1];

  var sliderElement = _react["default"].useRef();

  var sliderWidth = function sliderWidth() {
    var _sliderElement$curren, _sliderElement$curren2;

    return (_sliderElement$curren = (_sliderElement$curren2 = sliderElement.current) === null || _sliderElement$curren2 === void 0 ? void 0 : _sliderElement$curren2.getBoundingClientRect().width) !== null && _sliderElement$curren !== void 0 ? _sliderElement$curren : 0;
  };

  function getThumbPosition(thumbValue) {
    var ratio = (thumbValue - min) / (max - min);
    return thumbSize / 2 + ratio * sliderWidth() - ratio * thumbSize;
  }

  function getBackground() {
    var percentage = getThumbPosition(value) * 100 / sliderWidth();
    return {
      background: "linear-gradient(to right,\n        ".concat(disabled ? theme.color.disabled : theme.color.action, " ").concat(percentage, "%, transparent -").concat(100 - percentage, "%),\n        repeat ").concat(theme.pattern.graphPaper)
    };
  }

  function handleThumbFocusReposition() {
    setThumbFocusPosition(getThumbPosition(sliderElement.current.value));
  }

  function handleChange(event) {
    onChange(event);
  }

  function handleChangeEnd(event) {
    onChangeEnd(event);
  }

  _react["default"].useEffect(function () {
    handleThumbFocusReposition();
  }, [min, max, step, value]);

  _react["default"].useEffect(function () {
    window.addEventListener('resize', handleThumbFocusReposition);
    return function cleanUp() {
      window.removeEventListener('resize', handleThumbFocusReposition);
    };
  }, []);

  return /*#__PURE__*/_react["default"].createElement(Container, null, /*#__PURE__*/_react["default"].createElement(StyledRangeInput, _extends({
    ref: sliderElement,
    id: id,
    name: name,
    value: value,
    disabled: disabled,
    type: "range",
    min: min,
    max: max,
    step: step,
    style: getBackground(),
    onChange: handleChange,
    onMouseUp: handleChangeEnd,
    onTouchEnd: handleChangeEnd,
    onKeyUp: handleChangeEnd,
    role: "slider",
    "aria-valuemin": min,
    "aria-valuemax": max,
    "aria-valuenow": value
  }, rest)), /*#__PURE__*/_react["default"].createElement(ThumbFocus, {
    style: {
      left: thumbFocusPosition - thumbSize / 2
    }
  }));
}